import type { ReactNode } from 'react'
import { useEffect } from 'react'

/** A dialog over the dashboard. Escape closes it, because on a desktop that is expected. */
export function Modal({
  title,
  children,
  onClose,
  wide,
}: {
  title: string
  children: ReactNode
  onClose: () => void
  wide?: boolean
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.55)',
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        zIndex: 2000,
      }}
    >
      <div
        className="card"
        onClick={(event) => event.stopPropagation()}
        style={{ width: wide ? 720 : 440, maxHeight: '86vh', overflow: 'auto' }}
      >
        <div className="spread" style={{ marginBottom: 14 }}>
          <h2>{title}</h2>
          <button className="ghost" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  )
}
